module.exports = __webpack_public_path__ + "img/bg2.89574174.png";